// hooks/useTableData.ts
import { useState } from 'react';
import { PatientManagementRow } from './patient-management/usePatientManagement';
import { DoctorManagementRow } from '../pages/DoctorManagement/types';
import { RoleManagementRow } from './role-management/useRoleManagement';
import { DoctorVerificationRow } from '../pages/DoctorsVerification/List';
import { OrganisationDashboardRow } from './oganisation-management/useOrganisation';

// Row can be either a patient row or a doctor row
export type TableRow =
  | PatientManagementRow
  | DoctorManagementRow
  | RoleManagementRow
  | DoctorVerificationRow
  | OrganisationDashboardRow;

export interface TableDataState<T> {
  tableRows: T[];
  setTableRows: React.Dispatch<React.SetStateAction<T[]>>;
  hasMore: boolean;
  setHasMore: React.Dispatch<React.SetStateAction<boolean>>;
  totalCount: number;
  setTotalCount: React.Dispatch<React.SetStateAction<number>>;
  pageTimestamps: Map<number, string>;
  setPageTimestamps: React.Dispatch<React.SetStateAction<Map<number, string>>>;
  tableLoading: boolean;
  setTableLoading: React.Dispatch<React.SetStateAction<boolean>>;
}

export function useTableData<T extends TableRow>(): TableDataState<T> {
  const [tableRows, setTableRows] = useState<T[]>([]);
  const [hasMore, setHasMore] = useState(true);
  const [totalCount, setTotalCount] = useState(0);
  const [pageTimestamps, setPageTimestamps] = useState<Map<number, string>>(new Map());
  const [tableLoading, setTableLoading] = useState(false);

  return {
    tableRows,
    setTableRows,
    hasMore,
    setHasMore,
    totalCount,
    setTotalCount,
    pageTimestamps,
    setPageTimestamps,
    tableLoading,
    setTableLoading
  };
}
